module.exports = __webpack_public_path__ + "static/media/humidicula-ruziziensis.2615fc8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/humidicula-ruziziensis.jpg
// module id = 94
// module chunks = 0